import type { ReactNode } from 'react';

/** Icons available to KPI/count cards (shared by the Painel and its builder). */
export const KPI_ICONS: Record<string, ReactNode> = {
  users: (
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
  ),
  cap: <path d="M22 10 12 5 2 10l10 5 10-5zM6 12v5c0 1 2.5 2.5 6 2.5s6-1.5 6-2.5v-5" />,
  briefcase: (
    <path d="M20 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
  ),
  clock: <path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM12 7v5l3 2" />,
  flag: <path d="M4 21V4M4 4h13l-2.5 4L17 12H4" />,
  building: (
    <path d="M3 21h18M5 21V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16M9 8h2M9 12h2M9 16h2M15 12h2M15 16h2" />
  ),
  beaker: <path d="M9 3h6M10 3v6l-5 9a2 2 0 0 0 2 3h10a2 2 0 0 0 2-3l-5-9V3M7.5 15h9" />,
  chart: <path d="M3 3v18h18M7 14l4-4 3 3 5-6" />,
};

/** Tone presets for count cards (map to the .kpi-* badge colours). */
export const KPI_TONES: { value: string; label: string }[] = [
  { value: 'kpi-active', label: 'Azul' },
  { value: 'kpi-phd', label: 'Verde' },
  { value: 'kpi-admin', label: 'Destaque' },
  { value: 'kpi-pending', label: 'Âmbar' },
];

/** The badge glyph for a KPI/count card, by icon name (falls back to a chart). */
export function KpiGlyph({ name }: { name?: string | null }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {KPI_ICONS[name ?? 'chart'] ?? KPI_ICONS.chart}
    </svg>
  );
}
